export default __webpack_public_path__ + "static/media/logoT.cafcd207.jpg";